import React, { useState } from 'react'
import { Button, Form, Modal, Spinner } from 'react-bootstrap'
import axios from '../../../adapters/API/axios';
import Swal from 'sweetalert2';

function ModalVisitOutComp({
    openModalVisitOut,
    setOpenModalVisitOut,
    location,
    userInfo,
    tokenUser,
    win
}) {

    const [visitPlaceOut, setVisitPlaceOut] = useState('');
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [pictures, setPictures] = useState(null);

    const [disabled, setDisabled] = useState(false)

    const handleCloseModalVisitOut = () => {
        setOpenModalVisitOut(false)
        setVisitPlaceOut('');
        setPictures(null);
    }

    const handleImageChange = (e) => {
        const file = e.target.files[0];
        if (file) {
            setPictures(file);
        }
    };

    const handleSubmitVisitOut = async (event) => {
        event.preventDefault();
        const checkFunctionVisitInId = JSON.parse(localStorage.getItem('visitInId'));

        setDisabled(true);
        setIsSubmitting(true);

        const formData = new FormData();
        formData.append('visitOut_location', `POINT(${location?.longitude} ${location?.latitude})`);
        formData.append('user', userInfo?.id);
        formData.append('visitOut_place', visitPlaceOut);
        formData.append('visitIn', checkFunctionVisitInId || "");
        formData.append('picture', pictures);

        try {
            const response = await axios.post(`/api/visit/visitOut/`, formData,
                {
                    headers: {
                        'Content-Type': 'multipart/form-data',
                        Authorization: `Token ${tokenUser}`,
                    },
                }
            );

            // console.log(response)

            Swal.fire({
                icon: 'success',
                title: 'Visit Keluar diterima',
                showConfirmButton: false,
                timer: 2000
            })

            localStorage.removeItem('visitInId' || "");

            handleCloseModalVisitOut();
            setDisabled(false);
            setIsSubmitting(false);

        } catch (err) {
            console.log(err)
            if (!err?.response) {
                Swal.fire({
                    icon: 'error',
                    title: 'Warning!',
                    text: 'Terjadi kesalahan saat Visit Keluar',
                })
                setDisabled(false);
                setIsSubmitting(false);
            } else if (err.response?.status === 400) {
                let str = err.response?.data.error;
                let str2 = str.replace(/\[|\]|\'/g, "");
                Swal.fire({
                    icon: 'error',
                    title: 'Warning!',
                    text: str2,
                });
                setDisabled(false);
                setIsSubmitting(false);

            }
            else if (err.response?.status === 413) {
                Swal.fire({
                    icon: 'error',
                    title: 'Warning!',
                    text: 'File terlalu besar',
                })
                setDisabled(false);
                setIsSubmitting(false);
            };
        };
    };


    return (
        <Modal
            show={openModalVisitOut}
            onHide={handleCloseModalVisitOut}
            backdrop="static"
            keyboard={false}
            centered
        >

            <Modal.Header closeButton>
                <Modal.Title style={{ fontFamily: 'Poppins-Medium' }}>
                    Visit Keluar
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Form onSubmit={handleSubmitVisitOut} >
                    <Form.Group className="mb-3">
                        <Form.Label style={formStyles.label}>Upload Foto*</Form.Label>
                        <Form.Control
                            type="file"
                            accept="image/*"
                            capture="environment"
                            onChange={handleImageChange}
                            disabled={disabled}
                            style={formStyles.inputImage}
                            required
                        />
                    </Form.Group>
                    <Form.Group className="mb-3">
                        <Form.Label style={formStyles.label} htmlFor='visitPlace'>Lokasi Visit*</Form.Label>
                        <Form.Control
                            id='visitPlace'
                            type="text"
                            value={visitPlaceOut}
                            onChange={(e) => setVisitPlaceOut(e.target.value)}
                            required
                            disabled={disabled}
                            style={formStyles.input}
                        />
                    </Form.Group>
                    <div className="d-grid gap-2">
                        {isSubmitting ? (
                            <Button
                                type="submit"
                                // id='actionButtonLogin'
                                variant='btn'
                                disabled={disabled}
                                style={{ backgroundColor: '#12B3ED', color: 'white', fontFamily: 'Poppins-Regular' }}>
                                <Spinner animation="border" size='sm' style={{ color: '#FFFFFF' }} />
                            </Button>
                        ) : (
                            <Button
                                variant="btn"
                                type='submit'
                                disabled={!visitPlaceOut || !pictures || disabled}
                                style={{ backgroundColor: '#12B3ED', color: 'white', fontFamily: 'Poppins-Regular' }}>
                                Kirim
                            </Button>
                        )}
                    </div>
                </Form>
            </Modal.Body>
        </Modal>
    )
}

export default ModalVisitOutComp


const formStyles = {
    label: {
        fontFamily: 'Poppins-Medium',
        color: '#222',
    },
    input: {
        color: '#222',
        fontFamily: 'Poppins-Regular',
        minHeight: '50px',
        borderColor: '#ced4da', // Initial border color
    },
    inputImage: {
        color: '#222',
        fontFamily: 'Poppins-Regular',
        borderColor: '#ced4da', // Initial border color
    },
};
